import {
  ISearchCustomerInRoute,
  ISearchCustomerInSalePlanning,
  ISearchCustomerInTeamSale,
} from 'interfaces/Customer';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import {
  CHECK_CUSTOMER_IS_MAIN_CUSTOMER,
  CHECK_DUPLICATE_CCCD,
  CHECK_DUPLICATE_TAX_ID,
  CHECK_USER_INFO,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_LINE_PRODUCT,
  CREATE_CUSTOMER_PLANT,
  DELETE_CUSTOMER_LINE_PRODUCT,
  GET_ALL_CUSTOMER,
  GET_CUS_LIST,
  GET_CUSTOMER_COMBOBOX,
  GET_CUSTOMER_IN_PLANT_COMBOBOX,
  GET_CUSTOMERS_IN_COMBOBOX,
  SEARCH_CUSTOMER_IN_ROUTE,
  SEARCH_CUSTOMER_IN_SALE_PLANNING,
  SEARCH_CUSTOMER_IN_TEAM_SALE,
  UPDATE_CUSTOMER,
} from './GraphQL/Queries/customerQuery';
import {
  CUSTOMER_VARIABLE,
  GET_CUSTOMERS_IN_COMBOBOX_MERGE_ORDER_VARIABLES,
  IGetCustomerCb,
  VARIABLE_GET_CUSTOMER_COMBOBOX,
  VARIABLE_UPDATE_CUSTOMER,
} from './GraphQL/Variables/customer';
import axiosClient from './setup/axiosClient';

export interface IGetCustomerParams {
  pageSize: number;
  value?: string;
}

export const CustomerApis = {
  getAllInComboBox: async (params: IGetCustomerCb) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMER_COMBOBOX,
      variables: VARIABLE_GET_CUSTOMER_COMBOBOX(params),
    });
  },
  createCus: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: CREATE_CUSTOMER,
      variables: CUSTOMER_VARIABLE.createCustomer(params),
    });
  },
  CreateCustomerPlant: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: CREATE_CUSTOMER_PLANT,
      variables: CUSTOMER_VARIABLE.CreateCustomerPlant(params),
    });
  },
  GetCustomerInPlantComBoBox: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMER_IN_PLANT_COMBOBOX,
      variables: CUSTOMER_VARIABLE.GetCustomerInPlantComBoBox(params),
    });
  },
  CheckDuplicateTaxId: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_DUPLICATE_TAX_ID,
      variables: CUSTOMER_VARIABLE.CheckDuplicateTaxId(params),
    });
  },
  checkDuplicateCCCD: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_DUPLICATE_CCCD,
      variables: CUSTOMER_VARIABLE.checkDuplicateCCCD(params),
    });
  },
  checkUserInfo: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_USER_INFO,
      variables: CUSTOMER_VARIABLE.checkUserInfo(id),
    });
  },
  CreateCustomerLineProduct: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: CREATE_CUSTOMER_LINE_PRODUCT,
      variables: CUSTOMER_VARIABLE.CreateCustomerLineProduct(params),
    });
  },
  deleteCustomerLineProduct: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: DELETE_CUSTOMER_LINE_PRODUCT,
      variables: CUSTOMER_VARIABLE.deleteCustomerLineProduct(id),
    });
  },
  exportCustomerToSap: (params: any) =>
    axiosClient.post(`/customer/export-to-sap`, params),
  getCustomerKycInfo: (sapCustomerId: string) =>
    axiosClient.get(`/customer-kyc/info/${sapCustomerId}`),
  updateCustomerKycInfo: (sapCustomerId: string, data: any) =>
    axiosClient.put(`/customer-kyc/info/${sapCustomerId}`, data),
  updateCustomer: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: UPDATE_CUSTOMER,
      variables: VARIABLE_UPDATE_CUSTOMER(params),
    });
  },
  checkMainCustomer: async (mainCustomerId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_CUSTOMER_IS_MAIN_CUSTOMER,
      variables: CUSTOMER_VARIABLE.checkMainCustomer(mainCustomerId),
    });
  },
  sendCustomerToSAP: async (customerId: string) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/customer-dms` as string,
      {
        customerId: customerId,
      },
    );
  },
  searchCustomerInRoute: (params: ISearchCustomerInRoute) =>
    axiosGraphQL.post('/graphql', {
      query: SEARCH_CUSTOMER_IN_ROUTE,
      variables: CUSTOMER_VARIABLE.searchCustomerInRoute(params),
    }),
  searchCustomerInTeamSale: (params: ISearchCustomerInTeamSale) =>
    axiosGraphQL.post('/graphql', {
      query: SEARCH_CUSTOMER_IN_TEAM_SALE,
      variables: CUSTOMER_VARIABLE.searchCustomerInTeamSale(params),
    }),
  searchCustomerInSalePlan: (params: ISearchCustomerInSalePlanning) =>
    axiosGraphQL.post('/graphql', {
      query: SEARCH_CUSTOMER_IN_SALE_PLANNING,
      variables: CUSTOMER_VARIABLE.searchCustomerInSalePlanning(params),
    }),
  getCustomersInCombobox: async (params: {
    pageSize: number;
    searchValue?: string;
    plantId?: string;
  }) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMERS_IN_COMBOBOX,
      variables: GET_CUSTOMERS_IN_COMBOBOX_MERGE_ORDER_VARIABLES(params),
    });
  },
  getCustomers: async (params: IGetCustomerParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_CUSTOMER,
      variables: CUSTOMER_VARIABLE.getCustomers(params),
    });
  },
  getCustomerList: async (id: string) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_CUS_LIST,
      variables: {
        input: {
          customerId: id,
        },
      },
    });
  },
};
